var map = {
  "./cs.json": [
    "kaT",
    [
      "e1"
    ]
  ],
  "./en.json": [
    "Fz",
    [
      "vxo"
    ]
  ],
  "./pl.json": [
    "nE",
    [
      "hd"
    ]
  ],
  "./ru.json": [
    "QW",
    [
      637
    ]
  ],
  "./tr.json": [
    "prG",
    [
      "jg6"
    ]
  ],
  "./ja.json": [
    "iaf",
    [
      "o6p"
    ]
  ],
  "./zh.json": [
    "KIx",
    [
      "4cv"
    ]
  ],
  "./pt-br.json": [
    "XN",
    [
      97
    ]
  ],
  "./de.json": [
    "OJ",
    [
      42
    ]
  ],
  "./es.json": [
    "YL9",
    [
      "ijj"
    ]
  ],
  "./fr.json": [
    "Lh",
    [
      "puo"
    ]
  ],
  "./it.json": [
    "fuB",
    [
      "lq"
    ]
  ],
  "./ko.json": [
    "huY",
    [
      "3db"
    ]
  ],
  "./pt.json": [
    "QNk",
    [
      "af"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "fv";
module.exports = __rspack_async_context;
